import { InitializeField } from './initialize-field.model';
import { IVoiceMapResponse } from '../interfaces/voice-map-response.interface';
import { AudioTour } from './audio-tour';

export class VoiceMapResponse
  extends InitializeField<IVoiceMapResponse>
  implements IVoiceMapResponse
{
  guidedTours: AudioTour[] = [];
  success: boolean = false;

  protected excludedKeys: string[] = [];

  constructor(data: Partial<IVoiceMapResponse> = {}) {
    super();
    this.guidedTours = this.mapToModelArray(data.guidedTours, AudioTour);
    this.initializeFields(data);
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      case 'success':
        return false;
      default:
        return null;
    }
  }
}
